<template>
  <figure
    role="button"
    tabindex="0"
    @mouseover="hover = true"
    @mouseleave="hover = false"
    @click="() => pushFeatures(features)"
    @keydown.enter="() => pushFeatures(features)"
    @keydown.space="() => pushFeatures(features)"
  >
    <div class="icon" :class="{ hover: hover }">
      <slot> </slot>
    </div>
    <figcaption>
      <SanitizedHtml :rawHtml="caption" />
    </figcaption>
  </figure>
</template>
<script lang="ts" setup>
import useFeatures from '@/pinia/features'
import SanitizedHtml from '@/design-system/atoms/SanitizedHtml.vue'
import { ref } from 'vue'
const { pushFeatures } = useFeatures()
const hover = ref(false)
type Props = {
  caption: string
  features: string[]
}
defineProps<Props>()
</script>
<style lang="scss" scoped>
@use '@/design-system/design-tokens/font-mixins';
@use '@/design-system/design-tokens/variables.scss';

figure {
  all: unset;
  width: 64px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  &:hover {
    cursor: pointer;
  }
  &:focus-visible {
    outline: auto;
  }
}
figcaption {
  @include font-mixins.desktop-regular-tiny;
  color: #1a1a1a;
  text-align: center;
  width: 64px;
  overflow-wrap: break-word;
}
.icon {
  width: 64px;
  height: 64px;
  padding: 20px;
  color: #181c71;
  background-color: #d5d7f6;
  border-radius: 8px;
  transition: background-color 0.2s ease;
  &.hover {
    background-color: #181c71;
    color: #d5d7f6;
  }
}
.section {
  display: flex;
  flex-direction: column;
}
</style>
